<alert type="info">
  <!-- <a href="https://www.boe.ca.gov/prop19/" target="_blank">
    <alert type="info">
      {{ "Prop19.Prop19Infov2" | translate }}
    </alert>

  </a> -->
  <p [innerHTML]="'ChangeinAddress.ImportantAlert'|translate"></p>
</alert>
<app-leveltwo [pageName]="'Change of Mailing Address'">

    <div class="General">
      <h3>{{'ChangeinAddress.PageTitle'|translate}}</h3>
      <p [innerHTML]="'ChangeinAddress.ItisImportant'|translate"></p>
     
      <p><i>The Change of Mailing Address form can be sent by mail to the address below or submitted online. Follow instructions as supporting documentation may be required.</i></p>
      <!-- <p>{{'ChangeinAddress.Itis'|translate}}</p>
      <b><p style="color:#AC2029" [innerHTML]="'ChangeinAddress.Important'|translate"></p></b> -->
      <p><b>{{'ChangeinAddress.Sendall'|translate}}</b>:</p>
      Los Angeles County Assessor’s Office<br>
      Ownership Division<br>
      500 W. Temple St., Room 205 <br>Los Angeles, CA 90012<br><br>
      <!-- <p>{{'ChangeinAddress.Formore'|translate}} <b>(213) 974-3441</b> {{'ChangeinAddress.oremailat'|translate}} <a href="mailto:addresschange@assessor.lacounty.gov">addresschange@assessor.lacounty.gov</a>.</p> -->
      <p [innerHTML]="'ChangeinAddress.Formore2'|translate"></p>


    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
